import { forwardRef, type ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

type AuthButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const AuthButton = forwardRef<HTMLButtonElement, AuthButtonProps>(
  ({ className, type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn("lmn-auth-submit lmn-auth-button-reset", className)}
      {...props}
    />
  )
);

AuthButton.displayName = "AuthButton";

export default AuthButton;
